import { isEqual } from 'lodash-es';
import { AutoRecallAnalyticsTypes } from '@frontend/api-analytics';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';
import { useAutoRecallAnalyticsDemoData } from './use-auto-recall-analytics-demo-data';

interface AutoRecallStore {
  defaultFilters: AutoRecallAnalyticsTypes.Filters;
  demoData: ReturnType<typeof useAutoRecallAnalyticsDemoData>;
  filterHintText: string;
  filters: AutoRecallAnalyticsTypes.Filters;
  hasCustomFilters: boolean;
  isDemoAccount?: boolean;
  locationId: string;

  setDefaultFilters: (defaultFilters: Partial<AutoRecallAnalyticsTypes.Filters>) => void;
  setDemoData: (demoData: ReturnType<typeof useAutoRecallAnalyticsDemoData>) => void;
  setFilterHintText: (filterHintText: string) => void;
  setFilters: (filters: Partial<AutoRecallAnalyticsTypes.Filters>) => void;
  setIsDemoAccount: (isDemoAccount: boolean) => void;
  setLocationId: (locationId: string) => void;

  resetStore: () => void;
}

const useAutoRecallStore = createStoreWithSubscribe<AutoRecallStore>(
  (set, get) => ({
    defaultFilters: {},
    demoData: null,
    filterHintText: '',
    filters: {},
    hasCustomFilters: false,
    isDemoAccount: undefined,
    locationId: '',

    setDefaultFilters: (defaultFilters) => {
      set({ defaultFilters });
    },
    setDemoData: (demoData) => {
      set({ demoData });
    },
    setIsDemoAccount: (isDemoAccount) => {
      set({ isDemoAccount });
    },
    setFilterHintText: (filterHintText) => {
      set({ filterHintText });
    },
    setFilters: (filters) => {
      const { defaultFilters, filters: currentFilters } = get();
      const newFilters: AutoRecallAnalyticsTypes.Filters = { ...currentFilters, ...filters };

      set({
        filters: newFilters,
        hasCustomFilters: Object.keys(newFilters).some(
          (key) =>
            !isEqual(
              newFilters[key as keyof AutoRecallAnalyticsTypes.Filters],
              defaultFilters[key as keyof AutoRecallAnalyticsTypes.Filters]
            )
        ),
      });
    },
    setLocationId: (locationId) => {
      set({ locationId });
    },

    resetStore: () => {
      set({
        defaultFilters: {},
        demoData: null,
        filterHintText: '',
        filters: {},
        hasCustomFilters: false,
        isDemoAccount: undefined,
        locationId: '',
      });
    },
  }),
  {
    name: 'AutoRecallStore',
    trace: true,
  }
);

export const useAutoRecallShallowStore = createShallowStore<AutoRecallStore>(useAutoRecallStore);
